import React from 'react';
import {Col, Row, Card, Modal, Button, Table, Tag, Empty} from 'antd';
import style from './Content.module.css';
import Axios from '../../utils/axios';
import Util from '../../utils/utils';

const rankColors = ['#c9962e', '#c7c7c7', '#d4894d', '#6f9c8d', '#7a8ea8'];

function RankList({data, showTotal}) {
    if (!data || data.length === 0) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据"/>;
    }
    const total = showTotal ? data.reduce((s, it) => s + (Number(it.count) || 0), 0) : null;
    return (
        <div className={style['rankList']}>
            {data.slice(0, 10).map((item, index) => (
                <div className={style['rankItem']} key={index}>
                    <span
                        className={style['rankIndex']}
                        style={{background: rankColors[index] || '#b9cec4'}}>
                        {index + 1}
                    </span>
                    <span className={style['rankName']} title={item.name || '-'}>{item.name || '-'}</span>
                    <span className={style['rankCount']}>{item.count}</span>
                </div>
            ))}
            {showTotal && (
                <div className={style['rankTotal']}>
                    <span className={style['rankTotalLabel']}>合计</span>
                    <span className={style['rankCount']}>{total}</span>
                </div>
            )}
        </div>
    );
}

class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statistics: null,
            loading: false,
            viewReserve: false,
        };
    }

    componentDidMount() {
        this.loadStatistics();
    }

    loadStatistics() {
        const userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (Util.isEmpty(userName)) {
            return;
        }
        this.setState({loading: true});
        Axios({
            method: "get",
            url: "/order/homeStatistics",
            params: {
                orderBy: userName,
                isOrderByName: false,
            }
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({statistics: res.data.data, loading: false});
            } else {
                this.setState({loading: false});
            }
        }).catch(() => {
            this.setState({loading: false});
        });
    }

    render() {
        const {statistics, viewReserve} = this.state;
        const reserveList = statistics ? (statistics.dayReserveList || []) : [];

        const reserveColumns = [
            {title: '车牌', dataIndex: 'licensePlate', width: 120},
            {title: '车主', dataIndex: 'ownerName', width: 110},
            {title: '手机号', dataIndex: 'ownerTel', width: 130},
            {title: '预约站点', dataIndex: 'siteName', ellipsis: true},
            {title: '预约时间', dataIndex: 'orderTime', width: 170, render: (v) => (v ? String(v).substring(0, 10) : '-')},
            {title: '车型', dataIndex: 'carModel', width: 120},
            {
                title: '状态',
                dataIndex: 'status',
                width: 90,
                render: (v) => v === 1
                    ? <Tag color="green">已完成</Tag>
                    : v === 2
                        ? <Tag color="red">已取消</Tag>
                        : <Tag color="blue">已预约</Tag>
            },
        ];

        return (
            <div className={style['content']} id='content'>
                <div id="content" className={style['content_info']}>
                    <div className={style['statHeader']}>
                        <img className={style['logo']} src="/logo.png" alt="JWS"/>
                        <span className={style['statTitle']}>数据统计</span>
                        <Button
                            size="small"
                            type="default"
                            onClick={() => this.loadStatistics()}
                            style={{marginLeft: 12}}>
                            刷新
                        </Button>
                    </div>

                    <Row gutter={[20, 20]}>
                        {/* 当日新增订单排行 */}
                        <Col xs={24} lg={12}>
                            <Card className={style['statCard']} bordered={false} loading={this.state.loading}
                                  title={<span className={style['cardTitle']}>当日新增订单排行</span>}>
                                <RankList data={statistics ? statistics.dayNewByOrder : null} showTotal/>
                            </Card>
                        </Col>
                        {/* 当日业绩排行 */}
                        <Col xs={24} lg={12}>
                            <Card className={style['statCard']} bordered={false} loading={this.state.loading}
                                  title={<span className={style['cardTitle']}>当日业绩排行</span>}>
                                <RankList data={statistics ? statistics.dayPerfByOrder : null} showTotal/>
                            </Card>
                        </Col>
                        {/* 当月业绩排行 */}
                        <Col xs={24} lg={12}>
                            <Card className={style['statCard']} bordered={false} loading={this.state.loading}
                                  title={<span className={style['cardTitle']}>当月业绩排行</span>}>
                                <RankList data={statistics ? statistics.monthPerfByOrder : null} showTotal/>
                            </Card>
                        </Col>
                        {/* 当日预约排行 */}
                        <Col xs={24} lg={12}>
                            <Card className={style['statCard']} bordered={false} loading={this.state.loading}
                                  title={
                                      <span className={style['cardTitle']}>
                                          当日预约排行
                                          {statistics ? (
                                              <Tag color="gold" style={{marginLeft: 12}}>
                                                  今日预约总数：{statistics.dayReserveTotal || 0}
                                              </Tag>
                                          ) : null}
                                      </span>
                                  }
                                  extra={
                                      <Button size="small" type="primary" ghost
                                              onClick={() => this.setState({viewReserve: true})}>
                                          查看明细
                                      </Button>
                                  }>
                                <RankList data={statistics ? statistics.dayReserveByOrder : null}/>
                            </Card>
                        </Col>
                    </Row>
                </div>

                {/* 当日预约明细弹窗 */}
                <Modal
                    title={'当日预约明细（共 ' + (statistics ? statistics.dayReserveTotal || 0 : 0) + ' 条）'}
                    visible={viewReserve}
                    width={900}
                    footer={null}
                    onCancel={() => this.setState({viewReserve: false})}>
                    <Table
                        rowKey="id"
                        size="small"
                        columns={reserveColumns}
                        dataSource={reserveList}
                        pagination={{pageSize: 8}}
                        scroll={{x: 900}}
                    />
                </Modal>
            </div>
        )
    }
}

export default Content;